import Departamentos from '@/components/ADepartamentos.vue';
import Paises from '@/components/APaises.vue';
import Ciudades from '@/components/ACiudades.vue';
import Universidades from '@/components/AUniversidades.vue';
import Profesiones from '@/components/AProfesiones.vue';
import Grados from '@/components/AGrados.vue';
import Empresas from '@/components/AEmpresas.vue';
import Alertas from '@/components/AAlertas.vue';
import Fecha from '@/components/AFecha.vue';
import { Validator } from 'simple-vue-validator';
import gql from 'graphql-tag';
import { parseJsonError } from '@/components/Utils.js';

export default {
  data() {
    return {
      activo: true,
      loading: false,
      onlyreaddata: true,
      preinscribir: true,
      apiwhatsapp: '',
      msg: '',
      api_whassap: process.env.VUE_APP_API_WHATSAPP,
      programa: {},
      grado: { id: -1 },
      telefonows: null,
      newEstudiante: {
        num_doc: null,
        nombres: null,
        pri_apellido: null,
        email: null,
        sexo: null,
        tipo: 'E',
        diestro: true,
        profesiones: [],

        idempresa: null,
        grados: [],
        idinstitucion: null,
        iddepartamento: null,
        idpais: null,
        idciudad: null,
        contacto: null,
        domicilio: null,
        datos_laborales: null,
        est_civil: null,
        fecha_nac: null,
        telefono2: null,
        telefono1: null,
        seg_apellido: null,
        usuario_moodle: null,
        clave_moodle: null,

        //este no esta, debe ser concatenado a datos laborales
        cargo: null,
      },
      username_moodle_is_blank: false,
      password_moodle_is_blank: false,
      cuotas: [],
    };
  },
  components: { Departamentos, Ciudades, Universidades, Profesiones, Grados, Empresas, Alertas, Fecha, Paises },
  validators: {
    'newEstudiante.num_doc'(value) {
      // return Validator.value(value).required().minLength(5).regex('^[1-9]\\d{5,14}(\\-([A-Z0-9]{1,2}))?$');
      return Validator.value(value).required().minLength(5);
    },
    'newEstudiante.nombres'(value) {
      return Validator.value(value)
        .required()
        .minLength(3)
        .regex('^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$');
    },
    'newEstudiante.pri_apellido'(value) { 
      return Validator.value(value) 
        .minLength(3)
        .regex('^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$');
    },
    'newEstudiante.email'(value) {
      return Validator.value(value).email().required();
    },
    'newEstudiante.sexo'(value) {
      return Validator.value(value).required();
    },
    'newEstudiante.profesiones'(value) {
      return Validator.value(value).required();
    },
    'newEstudiante.idpais'(value) {
      return Validator.value(value).required();
    },
    'newEstudiante.iddepartamento'(value) {
      return Validator.value(value);
    },
    'newEstudiante.usuario_moodle'(value) {
      return Validator.value(value).minLength(4).required();
    },
    'newEstudiante.clave_moodle'(value) {
      return Validator.value(value).minLength(4).required();
    },

    'newEstudiante.telefono1'(value) {
      return Validator.value(value).digit().minLength(5).maxLength(20);
    },
    'newEstudiante.telefono2'(value) {
      return Validator.value(value).digit();
    },
    'newEstudiante.seg_apellido'(value) {
      return Validator.value(value)
        .minLength(0)
        .regex('^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$');
    },
    'newEstudiante.datos_laborales'(value) {
      return Validator.value(value)
        .minLength(0)
        .regex('^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$');
    },
    'newEstudiante.cargo'(value) {
      return Validator.value(value)
        .minLength(0)
        .regex('^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$');
    },
    'newEstudiante.contacto'(value) {
      return Validator.value(value).digit();
    },
    'newEstudiante.domicilio'(value) {
      return Validator.value(value)
        .required()
        .minLength(0);
        // .regex('^([a-zñáéíóúA-ZÁÉÍÓÚÑ 0-9])([a-zñáéíóúA-ZÁÉÍÓÚÑ 0-9 % # ° / : , \' " “ ” - . _ & ()]+)$');
    },
  },
  watch: {
    newEstudiante: {
      deep: true,
      handler(a) {
        if (a == null) return;
        this.$refs.alertar.reset();
        this.msg = '';
        this.preinscribir = true;
        window.sessionStorage.setItem('xnewEstudiante', JSON.stringify(this.newEstudiante));
      },
    },

    'newEstudiante.nombres': function () {
      this.crearClave();
    },
    'newEstudiante.pri_apellido': function () {
      this.crearClave();
    },
    'newEstudiante.seg_apellido': function () {
      this.crearClave();
    },
    'newEstudiante.fecha_nac': function () {
      this.crearClave();
    },
    'newEstudiante.num_doc': function () {
      this.crearLogin();
    },
    // 'newEstudiante.iddepartamento': function () {
    //   this.crearLogin();
    // },
    telefonows: function () {
      let limpio = this.telefonows.replace('+', '');
      limpio = limpio.replace(/ /g, '');
      this.newEstudiante.telefono1 = limpio;
    },
    '$store.state.CARGO': function () {
      this.limitar();
    },
  },
  methods: {
    async getEstudiante(id) {
      this.loading = true;
      const vue = this;
      this.$refs.alertar.cargando();
      var sql = gql`
          query{
            getPersona(id:${id}){
              sexo,tipo,fecha_nac,est_civil,departamento{id,nombre,extension},idpais,pais{id, nombre},ciudad{id,nombre},
              contacto,datos_laborales,grados{id,titulo,nombre,nivel},profesiones{id,nombre},institucion{id,nombre}
              empresa{id,nombre},
              usuario_moodle,
              clave_moodle
            }
          }
        `;
      await this.$apollo
        .query({
          query: sql,
        })
        .then((data) => {
          var xp = data.data.getPersona;
          this.newEstudiante.contacto = xp.contacto;
          this.newEstudiante.idciudad = xp.ciudad;
          this.newEstudiante.iddepartamento = xp.departamento;
          this.newEstudiante.idinstitucion = xp.institucion;
          this.newEstudiante.profesiones = xp.profesiones;
          this.newEstudiante.datos_laborales = xp.datos_laborales;
          this.newEstudiante.fecha_nac = xp.fecha_nac;
          this.newEstudiante.sexo = xp.sexo;
          this.newEstudiante.tipo = xp.tipo;
          this.newEstudiante.est_civil = xp.est_civil;
          this.newEstudiante.idpais = xp.pais;
          this.$refs.alertar.reset();
          this.loading = false;

          var gdrs = this.sortGrados(xp.grados);
          if (gdrs.length > 0) this.grado = gdrs[0];
          // window.console.log('GRADOSSSSSSS:', gdrs);
          // window.console.log('GRADO:', xp);

          this.datosDefault();
        })
        .catch((error) => {
          window.console.error(error);
          this.$notify(parseJsonError(error, 'getSemaforos'));
          vue.loading = false;
        });
    },
    /* crearLoginX() {
      var a = this.newEstudiante.nombres;
      var ap = this.newEstudiante.pri_apellido;
      var am = this.newEstudiante.seg_apellido;
      var inicial = '';
      var aa = '';
      var mm = '';
      if (a && a.length > 0) {
        inicial = a.substring(0, 1);
      }
      if (ap && ap.length > 0) {
        aa = ap.replace(/\s+/g, '');
      }
      if (am && am.length > 0) {
        mm = am.replace(/\s+/g, '');
      }
      var logi = inicial + aa + mm;
      logi = getCleanedString(logi);
      //this.newEstudiante.usuario_moodle = this.newEstudiante.usuario_moodle.toLowerCase()
      if(this.username_moodle_is_blank){
        this.newEstudiante.usuario_moodle = logi;
      }
    }, */
    crearLogin(){
      const ci = this.newEstudiante.num_doc;
      if(!this.newEstudiante.usuario_moodle){
        if(ci) this.newEstudiante.usuario_moodle = ci;
      }
    },
    sortGrados(grados) {
      if (!grados) return [];
      grados = grados.sort(function (a, b) {
        return a.nivel - b.nivel;
      });
      return grados;
    },
    crearClave() {
      const f = this.newEstudiante.fecha_nac;
      const a = this.newEstudiante.nombres;
      const ap = this.newEstudiante.pri_apellido;
      const am = this.newEstudiante.seg_apellido;
      const logi = this.$generarCodigoPersona(f, a, ap, am);
      if(this.username_moodle_is_blank){ 
        this.newEstudiante.clave_moodle = logi;
      }
    },

    validarCamposEst() {
      //
      if (!this.activo) return;
      if( this.newEstudiante.fecha_nac ){
        let d = new Date(this.newEstudiante.fecha_nac);
        let f = new Date().getFullYear();
        if(d.getFullYear() <= 1900 || d.getFullYear() > f){ 
          this.$root.$notify.show(`fecha de nacimiento no valida`, {color:'red',x: 'right',});
          return;
        }
      }

      this.activo = false;
      this.$validate().then((success) => {
        var obj = window.Object.assign({}, this.newEstudiante);
        if (success) {
          var ids = [];
          obj.profesiones.forEach(function (e) {
            ids.push(e.id);
          });
          delete obj.profesiones;
          if (obj.domicilio) obj.domicilio = obj.domicilio.trim();
          obj.profesiones = ids;
          this.simpleValues(obj);
          this.$store.state.obj = obj;
          this.$store.dispatch('quitarNulos');
          if (!obj.seg_apellido) obj.seg_apellido = '';
          if (obj.idpais) obj.idpais = obj.idpais.id;

          window.console.log(window.stringifyObject(obj));
          this.$refs.alertar.cargando();
          this.enviarDAtos(obj);
        } else {
          // window.console.log( window.stringifyObject(obj) );
          this.$refs.alertar.invalido();
          this.activo = true;
        }
      });
    },
    simpleValues(obj) {
      if (obj.idempresa != null) obj.idempresa = obj.idempresa.id;
      if (obj.iddepartamento != null) obj.iddepartamento = obj.iddepartamento.id;
      if (obj.idciudad != null) obj.idciudad = obj.idciudad.id;
      if (obj.iduniversidad != null) obj.idinstitucion = obj.iduniversidad.id;
      if (!obj.cargo) obj.cargo = '';
      if (obj.datos_laborales != null) {
        obj.datos_laborales = obj.cargo + ' ' + obj.datos_laborales;
        obj.datos_laborales = obj.datos_laborales.trim();
      }
      if (obj.idgrado != null) {
        obj.grados = [];
        obj.grados.push({ idgrado: obj.idgrado.id, titulo: obj.idgrado.nombre });
      } else obj.datos_laborales = obj.cargo;
      delete obj.iduniversidad;
      delete obj.cargo;
      delete obj.idgrado;
    },

    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async enviarDAtos(obj) {
      // obj.tipo = "E";
      if(obj.tipo != 'E' || obj.tipo != 'P' || obj.tipo != 'D' ) obj.tipo = 'E';
      var vue = this;
      var sql = gql`mutation{ updatePersona(input:${window.stringifyObject(obj)}){ok,errors{message}} }`;
      vue.msg = ''; 
      window.console.log(sql);

      let cargo_id = this.$store.state.CARGO.id;
      if(cargo_id != 1){
        await this.sleep(3000); 
        this.$root.$notify.show(`No access`, {color:'black',x: 'right',});
        return;
      }

      this.$apollo
        .mutate({
          mutation: sql,
        })
        .then((data) => {
          if (data.data.updatePersona.ok) {
            vue.$refs.alertar.success();
            window.sessionStorage.setItem('xnewEstudiante', null);
            this.activo = true;
            vue.msg = '';
          } else {
            var errores = JSON.stringify(data.data.updatePersona.errors);
            var obj = JSON.parse(errores);
            var vals = '';
            obj.forEach(function (k) {
              vals += Object.values(k) + '-\n\t';
            });
            vue.msg = '';
            vue.activo = true;
            vue.$refs.alertar.invalido(vals);
          }

          window.console.log(data);
        })
        .catch((error) => {
          vue.$refs.alertar.invalido();
          this.activo = true;
          window.console.error(JSON.stringify(error));
          this.$notify(parseJsonError(error));
        });
    },
    datosDefault() {
      var xp = JSON.parse(sessionStorage.xestudiante);
      delete xp.profesiones;
      if(xp.usuario_moodle){
        this.newEstudiante.usuario_moodle = xp.usuario_moodle;
      }
      this.newEstudiante.clave_moodle = xp.clave_moodle;
    },
    limitar() {
      let cargo_id = this.$store.state.CARGO.id;
      let user_id = this.$store.state.DATA_USER.id;
      // window.console.log('?', cargo_id);
      this.onlyreaddata = true;

      if (cargo_id == 1 || cargo_id == -8 ) {
        this.onlyreaddata = false;
        if (user_id == -43) this.onlyreaddata = true;
      }
    },
  },
  mounted() {
    this.limitar();
    var xp = JSON.parse(sessionStorage.xestudiante); 

    if (!xp.telefono2) xp.telefono2 = '';
    this.newEstudiante.id = xp.id;
    this.newEstudiante.num_doc = xp.num_doc;
    this.newEstudiante.nombres = xp.nombres;
    this.newEstudiante.pri_apellido = xp.pri_apellido;
    this.newEstudiante.seg_apellido = xp.seg_apellido;
    this.newEstudiante.domicilio = xp.domicilio;
    this.newEstudiante.telefono1 = xp.telefono1;
    this.newEstudiante.telefono2 = xp.telefono2;
    this.newEstudiante.email = xp.email;
    if (this.newEstudiante.telefono1 && this.newEstudiante.telefono1.length == 8) {
      this.telefonows = '+591' + this.newEstudiante.telefono1;
    } else {
      this.telefonows = this.newEstudiante.telefono1;
    }

    if(!xp.usuario_moodle) this.username_moodle_is_blank = true;
    if(!xp.clave_moodle) this.password_moodle_is_blank = true;
 

    this.getEstudiante(xp.id);
  },
};
